import React from 'react';
import { personal, aboutChips } from '../data/portfolioData';
import photo from '../photo.jpg';
import './About.css';

export default function About() {
  return (
    <section id="about">
      <div className="about-grid">
        {/* Left card — compact identity card, NO repeated contact links */}
        <div className="about-card-wrap">
          <div className="about-card">
            <img src={photo} alt="Shakeel Khan" className="about-photo" />
            <div className="about-name-big">{personal.name}</div>
            <div className="about-role-tag">{personal.title}</div>

            <div className="about-detail">
              <span className="detail-icon">📍</span>
              <span>Karachi, Pakistan · Open to Remote</span>
            </div>
            <div className="about-detail">
              <span className="detail-icon">✉️</span>
              <a href={`mailto:${personal.email}`} className="about-link">
                {personal.email}
              </a>
            </div>
            <div className="about-detail">
              <span className="detail-icon">💼</span>
              <a href={personal.linkedin} target="_blank" rel="noopener noreferrer" className="about-link">
                My LinkedIn
              </a>
            </div>
            <div className="about-detail">
              <span className="detail-icon">🐙</span>
              <a href={personal.github} target="_blank" rel="noopener noreferrer" className="about-link">
                My GitHub
              </a>
            </div>

            <div className="about-available">
              <span className="avail-dot" />
              Available for opportunities
            </div>
          </div>
        </div>

        {/* Right text */}
        <div className="about-text-side">
          <div className="section-label">About Me</div>
          <h2 className="section-title">
            Building intelligent,<br />decentralised systems
          </h2>
          <p>
            I'm a Blockchain and Full Stack engineer with 4+ years building production systems at the
            intersection of AI, Web3, and distributed infrastructure. From RAG-based AI assistants
            and on-chain incentive systems to post-quantum cryptographic primitives — I work at the
            deep end of the stack.
          </p>
          <p>
            My smart-contract work spans Solidity, DeFi protocols, ERC token standards
            (20/721/721A/1155/2981), multi-sig vaults, and EIP-712 off-chain signing. On the backend
            I architect event-driven systems, distributed schedulers, and high-throughput data
            pipelines.
          </p>
          <div className="tech-chips">
            {aboutChips.map(chip => (
              <span key={chip} className="chip">{chip}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
